import React, { useState } from 'react';
import { isNil } from 'lodash-es';
import { useClickAway } from '../../../../utils';
import styled from '../../../../styled';
import { useCascadeDropdownContext, } from '../useCascadeDropdownContext';
export const GeneralStyledOptionsPanel = styled.div `
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  width: 14rem;
  min-height: 20rem;
  border-radius: 0.25rem;
  padding: 0;
  background: ${({ theme }) => theme.colors.SNOW_100};
  box-shadow: 0 0.125rem 0.187rem rgba(54, 62, 81, 0.2),
    0 0 1rem rgba(54, 62, 81, 0.1);
`;
export const StyledOptionsPanel = styled(GeneralStyledOptionsPanel) `
  top: 100%;
  left: 0;
  z-index: 1;
`;
export const StyledSubOptionsPanel = styled(GeneralStyledOptionsPanel) `
  top: 0;
  left: 100%;
  border-left: 1px solid ${({ theme }) => theme.colors.INK_300};
  border-radius: 0 0.25rem 0.25rem 0;
  box-shadow: 0 0.125rem 0.187rem rgba(54, 62, 81, 0.2),
    0.75rem 0 1rem rgba(54, 62, 81, 0.1);
  cursor: initial;
`;
export const StyledSubOptionsPanelList = styled.div `
  max-height: 20rem;
  overflow-y: auto;
`;
export const StyledOption = styled.div `
  padding: 0.75rem;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.PRIMARY_200};
  }
`;
const defectWindowWidth = (callback) => (e) => {
    if (window.innerWidth > 480) {
        callback(e);
    }
};
export const useOptionsPanelOptionState = (value) => {
    const { setSelectedType } = useCascadeDropdownContext();
    const [isOpen, setIsOpen] = useState(false);
    // TODO: resolve child options panel disappear when mouse is over scrollbar in parent panel
    const onMouseEnter = defectWindowWidth(() => setIsOpen(true));
    const onMouseLeave = defectWindowWidth(() => setIsOpen(false));
    const onClick = e => {
        e.stopPropagation();
        return value && setSelectedType(value);
    };
    return {
        isOpen,
        setIsOpen,
        onMouseEnter,
        onMouseLeave,
        onClick,
    };
};
export const Option = ({ option: propOption, }) => {
    const { value, content, children: options = [], OptionsPanelWrapper = React.Fragment, } = propOption;
    const { isOpen, onMouseEnter, onMouseLeave, onClick } = useOptionsPanelOptionState(value);
    return (React.createElement(StyledOption, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick },
        content,
        (options === null || options === void 0 ? void 0 : options.length) > 0 && (React.createElement(StyledSubOptionsPanel, { isOpen: isOpen },
            React.createElement(OptionsPanelWrapper, null,
                React.createElement(StyledSubOptionsPanelList, null, options.map(option => (React.createElement(Option, { key: option.key, option: option })))))))));
};
export const OptionsPanel = ({ OptionsPanelWrapper = React.Fragment, }) => {
    const { options, isDropdownOpen, setIsDropdownOpen, optionRef } = useCascadeDropdownContext();
    useClickAway({
        onClickAway: () => setIsDropdownOpen(false),
        checkIsOutside: (event) => {
            var _a;
            return isDropdownOpen &&
                !isNil(optionRef === null || optionRef === void 0 ? void 0 : optionRef.current) &&
                !((_a = optionRef === null || optionRef === void 0 ? void 0 : optionRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target));
        },
    });
    return (React.createElement("div", { ref: optionRef },
        React.createElement(StyledOptionsPanel, { isOpen: isDropdownOpen },
            React.createElement(OptionsPanelWrapper, null, options === null || options === void 0 ? void 0 : options.map(option => (React.createElement(Option, { key: option.key, option: option })))))));
};
export default OptionsPanel;
//# sourceMappingURL=OptionsPanel.js.map